import { useState, useContext, useEffect } from 'react';

import UserRoleContext from 'context/user-role/context';

const useScreen = (screenKey = '') => {
  const { isOnlyQueryByAccessScreen, isAccessDeniedByScreen, isSuperAdmin } =
    useContext(UserRoleContext);

  const [onlyQuery, setOnlyQuery] = useState<boolean>(true);

  useEffect(() => {
    if (isSuperAdmin) {
      setOnlyQuery(false);
      return;
    }
    setOnlyQuery(isOnlyQueryByAccessScreen(screenKey));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [screenKey, isSuperAdmin]);

  return {
    onlyQuery,
    isAccessDeniedByScreen,
  };
};

export default useScreen;
